import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-slate-100 px-5 py-12 sm:py-16" data-id="element-53" data-mp="1blk9oxqpn104">
      <div className="mx-auto max-w-[680px]" data-id="element-54" data-mp="1gjlov7l0mg6b">
        <h2 className="text-center text-[1.6rem] font-extrabold uppercase leading-[0.95] tracking-tight text-slate-950 sm:text-[2rem]" data-id="element-55" data-mp="1gkeqxv914hi4">
          Frequently Asked Questions
        </h2>

        <div className="mt-7 space-y-2.5" data-id="element-56" data-mp="289qa18gln78l">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} className="rounded-lg border border-slate-200 bg-white" data-id="element-57" data-mp="1uhk1a7fs02j6" data-mpi={index}>
                <h3 data-id="element-58" data-mp="2n70tb3zhhhev">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left text-[0.95rem] font-extrabold uppercase leading-tight tracking-tight text-slate-950 transition-colors duration-150 ease-out hover:text-orange-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-700 sm:text-[1rem]" data-id="element-59" data-mp="2n6hcxrphf12y">
                    {faq.question}
                    <ChevronDownIcon className={`h-4 w-4 shrink-0 text-orange-700 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-60" data-mp="1ohq7hldafz7l" />
                  </button>
                </h3>
                {isOpen && <div className="space-y-2 border-t border-slate-200 px-5 py-4" data-id="element-61" data-mp="35584d70ltwy">
                    {faq.answer.map(paragraph => <p key={paragraph} className="text-[1rem] leading-relaxed text-slate-950" data-id="element-62" data-mp="3ue2hib6qpe7k">
                        {paragraph}
                      </p>)}
                    {faq.bullets && <ul className="grid gap-1.5 pt-1 sm:grid-cols-2" data-id="element-63" data-mp="285ptifzw8f08">
                        {faq.bullets.map(bullet => <li key={bullet} className="flex gap-2 text-[0.95rem] text-slate-800" data-id="element-64" data-mp="2c6jhtah8zvtn">
                            <span className="mt-[0.55rem] h-1.5 w-1.5 shrink-0 rounded-full bg-orange-700" aria-hidden="true" data-id="element-65" data-mp="2m4z675ow4qzg" />
                            {bullet}
                          </li>)}
                      </ul>}
                    {faq.closing && <p className="text-[1rem] font-extrabold text-slate-950" data-id="element-66" data-mp="34xtexhvx7mv8">
                        {faq.closing}
                      </p>}
                  </div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}